<template>
  <b-modal
    id="delete-modal"
    ref="deleteReplyModal"
    modal-class="delete-modal"
    size="sm">
    <div class="text-center">
      <h5>Are you sure you want to delete this instant reply?</h5>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
      <b-button
        :disabled="deleting"
        @click="commitDelete">
        Yes
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'DeleteReplyModal',
  data() {
    return {
      replyId: false,
      deleting: false,
    };
  },
  computed: {
    ...mapGetters({
      instantReplyDeleted: 'automation/instantReplyDeleted',
      apiError: 'automation/apiError',
    }),
  },
  watch: {
    instantReplyDeleted(deleted) {
      if (deleted) {
        this.deleting = false;
        this.$emit('deleted', deleted);
        this.$refs.deleteReplyModal.hide();
      }
    },
  },
  methods: {
    ...mapActions({
      deleteInstantReply: 'automation/deleteInstantReply',
    }),
    replyToDelete(replyId) {
      this.replyId = replyId;
    },
    commitDelete() {
      this.deleting = true;
      if (!this.isTemp(this.replyId)) {
        this.deleteInstantReply({
          merchant_id: this.$route.params.merchant_id,
          reply_id: this.replyId,
        });
      } else {
        this.deleting = false;
        this.$emit('deleted', this.replyId);
        this.$refs.deleteReplyModal.hide();
      }
    },
    isTemp(id) {
      return id.lastIndexOf('temp-', 0) === 0;
    },
    show() {
      this.$refs.deleteReplyModal.show();
    },
    hide() {
      this.deleting = false;
      this.$refs.deleteReplyModal.hide();
    },
  },
};
</script>
